module.exports = __webpack_public_path__ + "495dcba444e7150e1d8bc3034d51bf9d.png";